import { IConstraintCalendarRestrictionDetail } from '../../interfaces/iconstraint-calendar-restriction-detail';
import { Area } from '../area';
import { ConstraintCalendarRestriction } from '../constraint-calendar-restriction';

export class ConstraintCalendarRestrictionDetailBase {
  ConstraintCalendarRestrictionDetailId: number;
  ConstraintCalendarRestrictionId: number;
  AreaId: number;
  Description: string | null;
  EffectiveStartDate: Date | null;
  EffectiveFinishDate: Date | null;
  IsAnnual: boolean | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  ConstraintCalendarRestriction?: ConstraintCalendarRestriction;

  constructor(item?: IConstraintCalendarRestrictionDetail) {
    if (item) {

      this.ConstraintCalendarRestrictionDetailId = item.ConstraintCalendarRestrictionDetailId;
      this.ConstraintCalendarRestrictionId = item.ConstraintCalendarRestrictionId;
      this.AreaId = item.AreaId;
      this.Description = item.Description;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveFinishDate = item.EffectiveFinishDate ? new Date(item.EffectiveFinishDate) : null;
      this.IsAnnual = item.IsAnnual;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.ConstraintCalendarRestriction = new ConstraintCalendarRestriction(item.ConstraintCalendarRestriction);
    }
  }
}